module.exports = __webpack_public_path__ + "assets1783936157458/img/yunying.cb08f6f7.svg";